import Analytics from '../../../../../analytics';

export const faOnClearAllFilter = () => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.FILTER_ALL_CLEARED,
    event_value: 'filter_remove_all',
  });
};
